enum MedicalCriteriaParamType {
  INPUT = 'INPUT',
  CHECKBOX = 'CHECKBOX',
  MULTI_SELECT_TOGGLE_FIRST = 'MULTI_SELECT_TOGGLE_FIRST',
  MULTI_SELECT = 'MULTI_SELECT',
  MULTI_ANSWER_SELECT = 'MULTI_ANSWER_SELECT',
}

export default MedicalCriteriaParamType;
